var exports = {
  "jw": "SearchFilterChip.module__chip___SjZVVk",
  "xA": "SearchFilterChip.module__chipActive___SjZVVk",
  "mD": "SearchFilterChip.module__chipIcon___SjZVVk",
  "s5": "SearchFilterChip.module__chipContent___SjZVVk",
  "Zl": "SearchFilterChip.module__chipLabel___SjZVVk",
  "$j": "SearchFilterChip.module__chipLabelActive___SjZVVk",
  "ET": "SearchFilterChip.module__chipValue___SjZVVk",
  "cG": "SearchFilterChip.module__chipValueActive___SjZVVk",
  "DT": "SearchFilterChip.module__removeButton___SjZVVk",
};

module.exports = exports;
